/** Words for the <Noun> settings page (SA-1204 §4, SA-1217). */
export const pageTitle = (singular: string) => `${singular} settings`
export const TARGET_LABEL = 'First quote target'
export const TARGET_UNIT = 'minutes'
export const targetHelp = (minutes: number) =>
  `A first quote sent within ${minutes} minutes of the request counts as inside the target. It is a guideline shown on records, in the Priority view and on Home; nothing is enforced.`
export const BOUNDS_ERROR = 'Enter a whole number of minutes from 5 to 1440.'
export const SAVE = 'Save'
export const REMINDER_LABEL = 'Quote decision reminder'
export const REMINDER_HELP =
  "When a feasibility result offers options, the record's conversation gets a staff note about the outstanding Commercial decision after this many minutes. 0 turns it off."
export const REMINDER_BOUNDS_ERROR = 'Enter a whole number of minutes from 0 to 525600.'
export const SAVED = 'Saved.'
export const SAVE_FAILED = "Couldn't save the settings."
export const LOAD_FAILED = "Couldn't load the settings."
